module.exports = __webpack_public_path__ + "static/media/cp-signup.2962f578.png";